import React, { ReactElement } from 'react'
import { PageContainer } from '@copyrightagent/basic-components'
import useSetPageTitle from 'hooks/useSetPageTitle'
import useStyle from './style'
import Navigation from '../HomeLayout/Navigation'
import RegistrationCertificatesList from './components/RegistrationCertificatesList'
import { PageBody, Typography } from '@copyrightagent/basic-components'
import {
	NoRegistrationCertificateSelected,
	RegistrationCertificateDetails,
} from './components/RegistrationCertificateDetails'
import {
	Route,
	Switch,
	RouteComponentProps,
	withRouter,
} from 'react-router-dom'

const RegistrationCertificatesPage = ({
	match,
}: RouteComponentProps): ReactElement => {
	const classes = useStyle()

	useSetPageTitle('Registration Certificates')

	return (
		<>
			<Navigation />
			<PageContainer className={classes.container}>
				<Typography variant="h5" className={classes.title}>
					Registration Certificates
				</Typography>

				<PageBody className={classes.bodyContainer}>
					<div style={{ marginTop: 20, display: 'flex' }}>
						<Route path={match.path} component={RegistrationCertificatesList} />
						<div className={classes.divider} />
						<Switch>
							<Route
								exact
								path={match.path}
								component={NoRegistrationCertificateSelected}
							></Route>
							<Route
								path={`${match.path}/:registrationCertificateId`}
								component={RegistrationCertificateDetails}
							/>
						</Switch>
					</div>
				</PageBody>
			</PageContainer>
		</>
	)
}

export default withRouter(RegistrationCertificatesPage)
